import { useRef } from "react";
import {
  Box,
  Typography,
  Divider
} from "@mui/material";
import { useStyles, lightTheme } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import GrnPdfHeader from "../../components/documents/GrnPdfHeader";
import GrnPdfFooter from "../../components/documents/GrnPdfFooter";
import ViewDataGridPdf from "../../components/grid/ViewDataGridPdf";
import GrnPdfInfo from "../../components/documents/GrnPdfInfo";
import GrnPdfSupplier from "../../components/documents/GrnPdfSupplier";
import { ThemeProvider } from "@mui/material/styles";
import { FormatDate, FormatDateYYYYMM } from "../../utils/common/DateUtils";
import { GenerateNoteNumber } from "../../utils/common/SupportingFunctions";
import { CON_NOTE_REJECT } from "../../utils/sys/Constants";

const cellStyleLabel = {
  border: "1px solid black",
  fontWeight: "bold",
  fontSize: 12,
  textAlign: "right",
  px: 1,
  py: 0.5,
  bgcolor: "white",

  color: "black",
};

const cellStyleValue = {
  border: "1px solid black",
  // backgroundColor: "#f3f3f3",
  bgcolor: "white",

  color: "black",
  fontSize: 12,
  px: 1,
  py: 0.5,
  textAlign: "right",
};
function RejectionNotePdf({
  docType,
  grnHeader,
  selectedSupplier,
  grnDetailsForm,
  grnReturns,
  grnPaySummery,
  grnCompany,
  grnItems,
  grnData,
  grnRejectList,
} = {}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const summary = grnPaySummery?.[0] || {};
  const poData = grnHeader || grnDetailsForm || {};

  const formatCurrency = (val) =>
    new Intl.NumberFormat("en-LK", {
      // style: "currency",
      // currency: "LKR",
      minimumFractionDigits: 2,
    }).format(Number(val || 0));

const rejectionSource =
  Array.isArray(grnRejectList) && grnRejectList.length > 0
    ? grnRejectList
    : Array.isArray(grnReturns)
    ? grnReturns.filter((item) => item?.sts === "4")
    : [];
    
  const grnItemsRows = rejectionSource?.map((item, index) => {
    const matchedItem = grnItems?.find(
      (grnItem) => grnItem.productcode === item.productcode
    );
    const unitprice = matchedItem?.unitprice || 0;
    const returnedqty = item.returnedqty || item.rejectqty || 0;

    return {
      ...item,
      idno: index + 1,
      unitprice,
      totalprice: unitprice * returnedqty,
      id: item.productcode || index,
    };
  });

  
  const grnItemsColumns = [
    { field: "idno", headerName: "No" },

    { field: "productcode", headerName: "Item Code" },
    { field: "productname", headerName: "Item Name" },
    { field: "returnedqty", headerName: "Quantity" },
    // { field: "brandname", headerName: "Brand" },
    { field: "immeasuringunit", headerName: "UOM" },
    { field: "unitprice", headerName: "Unit Price", format: formatCurrency },

    // { field: "totalprice", headerName: "Total Amount", format: formatCurrency },
  ];

  const companyName = grnCompany?.compname || "N/A";
  const address1 = grnCompany?.compaddresS1 || "";
  const address2 = grnCompany?.compaddresS2 || "";
  const address3 = grnCompany?.compaddresS3 || "";
  const city = grnCompany?.city || "";
  const province = grnCompany?.province || "";
  const country = grnCompany?.country || "";
  const fullAddress = [address1, address2, address3, city, province, country]
    .filter(Boolean)
    .join(", ");

  const contact = grnCompany?.hotline || "N/A";
  const email = grnCompany?.email || "N/A";

  const poNumber = poData.ponumber ||  "-";
  const poDate = poData.podate || poData.poDate || null;
  const invoiceNumber = poData.invoiceno || poData.invoiceNumber || "N/A";
  const invoiceDate = poData.invoicedate || poData.invoiceDate || null;
  const deliveryNoteNumber =
    poData.deliverynoteno || poData.deliveryNoteNumber || "N/A";
  return (
    <ThemeProvider theme={lightTheme}>
      <div ref={printRef} id="print-section">
        <Box sx={{ maxWidth: 794, mx: "auto", p: 3, bgcolor: "white" }}>
          <GrnPdfHeader
            docType={docType}
            grnHeader={grnHeader}
            grnCompany={grnCompany}
            handlePrint={handlePrint}
          />

          <Divider
            sx={{
              borderColor: "#2a6db0",
              mb: 4,

              color: "black",
            }}
          />
          <Box
            mb={4}
            sx={{
              color: "black",
            }}
          >
            {/* <Typography variant="subtitle_s" component="span" fontWeight="bold">
              REJECTION NOTE NUMBER:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              RN7766544
            </Typography>
            <br /> */}
            {/* <Typography variant="subtitle_s" component="span" fontWeight="bold">
              DATE:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              09/05/2025
            </Typography>
            <br /> */}
            <Typography variant="body_xs" component="span" fontWeight="bold">
              REJECTION NOTE NUMBER:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              {GenerateNoteNumber(CON_NOTE_REJECT,FormatDateYYYYMM(invoiceDate), poData?.grncode)}
            </Typography>
            <br />
            <Typography variant="body_xs" component="span" fontWeight="bold">
            REJECTION NOTE DATE:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              {FormatDate(invoiceDate) || "-"} 
            </Typography>
            <br />
            <Typography variant="body_xs" component="span" fontWeight="bold">
              PO NUMBER:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              {poNumber}
            </Typography>
            <br />
            <Typography variant="body_xs" component="span" fontWeight="bold">
              PO DATE:
            </Typography>{" "}
            <Typography variant="body_xs" component="span">
              {FormatDate(poDate) || "-"}
            </Typography>
            <br />
          </Box>

          <Box sx={styles.sup_buy_container}>
            <Box sx={styles.sup_buy_container_inside}>
              <GrnPdfSupplier
                grnHeader={grnHeader}
                selectedSupplier={selectedSupplier}
              />
            </Box>
            {/* <Box sx={styles.sup_buy_container_inside}>
              <Typography variant="subtitle_s" fontWeight="bold" mb={0}>
                BUYER INFORMATION
              </Typography>
              <Typography variant="body_xs">
                <strong> COMPANY NAME :</strong> {companyName}
              </Typography>
              <br />
              <Typography variant="body_xs">
                <strong> ADDRESS :</strong> {fullAddress}
              </Typography>
              <br />{" "}
              <Typography variant="body_xs">
                <strong> CONTACT/PHONE :</strong> {contact}
              </Typography>
              <br />{" "}
              <Typography variant="body_xs">
                <strong> EMAIL :</strong> {email}
              </Typography>
              <br />
            </Box> */}
          </Box>

          <ViewDataGridPdf
            columns={grnItemsColumns}
            // rows={rows}
            // menuItems={menuItems}
            // tabletitle={ViewInitiatorGrnData.name}
            rows={grnItemsRows}
            gridid="productcode"
            sx={styles.view_data_grid_page}
          />

          {/* <Box
            display="flex"
            justifyContent="flex-end"
            mt={2}
            maxWidth={300}
            ml="auto"
          >
            <TableContainer
              component={Paper}
              sx={{ border: "1px solid black" }}
            >
              <Table size="small" sx={{ borderCollapse: "collapse" }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={cellStyleLabel}>TOTAL ITEMS</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {grnItemsRows.length}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={cellStyleLabel}>TOTAL GROSS</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {formatCurrency(summary.totgross)}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={cellStyleLabel}>PRODUCT DISCOUNT</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {formatCurrency(summary.totproductdiscount)}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={cellStyleLabel}>TAX</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {formatCurrency(summary.tottax)}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={cellStyleLabel}>PENALTY</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {formatCurrency(summary.totpenalty)}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyleLabel}>NET TOTAL</TableCell>
                    <TableCell sx={{ ...cellStyleValue, fontWeight: "bold" }}>
                      {formatCurrency(summary.totinvoice)}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyleLabel}>TOTAL INVOICE</TableCell>
                    <TableCell sx={cellStyleValue}>
                      {formatCurrency(summary.totinvoice)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box> */}
          {/* <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="body_xs">
          <strong> Reason for Issuance:</strong>
        </Typography>
        <Typography variant="body_xs">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          aliquet ullamcorper auctor. Nunc tellus massa, condimentum a bibendum
          a, vestibulum eu dolor.
        </Typography>
      </Box> */}
          <GrnPdfInfo grnHeader={grnHeader} />
          {/* <GrnPdfNotes /> */}
          <GrnPdfFooter />
        </Box>
      </div>
    </ThemeProvider>
  );
}

export default RejectionNotePdf;
